import React, { useState, useEffect } from 'react'
import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import {
  noteSuccessSaved,
  noteSuccessDeleted,
  noteSuccessUpdated,
} from '../messages'
import DialogCreateNote from './dialogs/DialogCreateNote'
import DialogEditNote from './dialogs/DialogEditNote'
import DialogDeleteNote from './dialogs/DialogDeleteNote'
import DialogDetailsNote from './dialogs/DialogDetailsNote'
import NotesPanel from './NotesPanel'
import NotesList from './NotesList'

const useStyles = makeStyles((theme) => ({
  notesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '43px 29px 40px 29px',
  },
}))

const DETAILS_NOTE_DIALOG = 'isOpenDetailsNoteDialog'
const CREATE_NOTE_DIALOG = 'isOpenCreateNoteDialog'
const EDIT_NOTE_DIALOG = 'isOpenEditNoteDialog'
const DELETE_NOTE_DIALOG = 'isOpenDeleteNoteDialog'
const PAGE_INIT = 1
const NOTES_LIMIT = 3

export default (props) => {
  let { subscriber } = props
  let subscriberId = subscriber.id

  const dispatchRedux = useDispatch()
  const styleClass = useStyles()

  let [state, setState] = useState({
    notes: [],
    isShowSeeMore: false,
    [CREATE_NOTE_DIALOG]: false,
    [EDIT_NOTE_DIALOG]: false,
    [DELETE_NOTE_DIALOG]: false,
    [DETAILS_NOTE_DIALOG]: false,
    noteId: null,
    selectedNote: null,
    page: PAGE_INIT,
  })

  let fetchNotes = (props = undefined) => {
    let params = {
        limit: NOTES_LIMIT,
        page: state.page,
        'filter[subscriberId]': subscriberId,
      },
      dialogId

    if (props !== undefined) {
      dialogId = props.dialogId
      params.page = PAGE_INIT
    }

    effects.apis.getNotesBySubscriberId(params).then((res) => {
      state.notes.push(...res.data)
      let newState = {
        ...state,
        notes: state.notes,
        isShowSeeMore: res.meta['currentPage'] < res.meta['lastPage'],
        noteId: null,
        selectedNote: null,
        [DETAILS_NOTE_DIALOG]: false,
      }

      let page = state.page
      if (dialogId) {
        newState[dialogId] = false
        newState.notes = [...res.data]
        page = PAGE_INIT
      }

      newState.page = page + 1
      setState(newState)
    })
  }

  useEffect(() => {
    fetchNotes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let openOrCloseCreateDialog = () => {
    setState({
      ...state,
      [CREATE_NOTE_DIALOG]: !state[CREATE_NOTE_DIALOG],
    })
  }

  let openOrCloseEditDialog = (selectedNote) => {
    let newState = {
      ...state,
      [EDIT_NOTE_DIALOG]: !state[EDIT_NOTE_DIALOG],
    }
    if (selectedNote) {
      newState.selectedNote = selectedNote
    }
    setState(newState)
  }

  let openOrCloseDeleteDialog = (noteId) => {
    let newState = {
      ...state,
      [DELETE_NOTE_DIALOG]: !state[DELETE_NOTE_DIALOG],
    }
    if (noteId) {
      newState.noteId = noteId
    }
    setState(newState)
  }

  let createNote = (data) => {
    data.subscriberId = subscriberId
    effects.apis
      .createNotes(data)
      .then((res) => {
        noteSuccessSaved(dispatchRedux)
        fetchNotes({
          limit: state.notes.length,
          dialogId: CREATE_NOTE_DIALOG,
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  let editNote = (data) => {
    effects.apis
      .updateNotes(data)
      .then((res) => {
        noteSuccessUpdated(dispatchRedux)
        fetchNotes({
          limit: state.notes.length,
          dialogId: EDIT_NOTE_DIALOG,
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  let deleteNote = () => {
    if (state.noteId) {
      effects.apis
        .deleteNoteById({ noteId: state.noteId })
        .then((res) => {
          noteSuccessDeleted(dispatchRedux)
          fetchNotes({
            limit: state.notes.length,
            dialogId: DELETE_NOTE_DIALOG,
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  let handleSeeMore = () => {
    fetchNotes()
  }

  let openOrCloseDetailsDialog = (selectedNote) => {
    let newState = {
      ...state,
      [DETAILS_NOTE_DIALOG]: !state[DETAILS_NOTE_DIALOG],
    }
    if (selectedNote) {
      newState.selectedNote = selectedNote
    }
    setState(newState)
  }

  return (
    <>
      <div className={styleClass.notesWrapper}>
        <NotesPanel openOrCloseCreateDialog={openOrCloseCreateDialog} />
        <NotesList
          state={state}
          openOrCloseDetailsDialog={openOrCloseDetailsDialog}
          openOrCloseEditDialog={openOrCloseEditDialog}
          openOrCloseDeleteDialog={openOrCloseDeleteDialog}
          handleSeeMore={handleSeeMore}
        />
      </div>

      {state[CREATE_NOTE_DIALOG] && (
        <DialogCreateNote
          fullName={`${subscriber.firstName} ${subscriber.lastName}`}
          openOrCloseCreateDialog={openOrCloseCreateDialog}
          createNote={createNote}
        />
      )}

      {state[EDIT_NOTE_DIALOG] && (
        <DialogEditNote
          fullName={`${subscriber.firstName} ${subscriber.lastName}`}
          openOrCloseEditDialog={openOrCloseEditDialog}
          editNote={editNote}
          note={state.selectedNote}
        />
      )}

      {state[DELETE_NOTE_DIALOG] && (
        <DialogDeleteNote
          openOrCloseDeleteDialog={openOrCloseDeleteDialog}
          deleteNote={deleteNote}
        />
      )}

      {state[DETAILS_NOTE_DIALOG] && (
        <DialogDetailsNote
          openOrCloseDetailsDialog={openOrCloseDetailsDialog}
          note={state.selectedNote}
          openOrCloseEditDialog={openOrCloseEditDialog}
          openOrCloseDeleteDialog={openOrCloseDeleteDialog}
        />
      )}
    </>
  )
}
